import React from 'react';
import ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.min.css';
import 'react-table/react-table.css';
import './styles/index.css';
import App from './App';
import { unregister as unregisterServiceWorker } from './extras/registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js